/* ===========================================================
   JOUBERT — Diaporama : le pilotage.

   Le script pose data-prete sur le bloc, et c'est cet attribut qui
   arme toutes les regles de transition de la feuille. Une page dont
   le script ne part pas affiche donc la premiere diapositive en
   entier, texte compris, au lieu d'un cadre noir.

   Etats d'une diapositive :
     attente  — hors champ, prete a entrer
     active   — a l'ecran
     sortante — en train de quitter, le temps de la transition
   =========================================================== */

(function () {
  'use strict';

  var SOBRE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function monte(bloc) {
    if (bloc.dataset.monte) return;
    bloc.dataset.monte = 'oui';

    var vues = Array.prototype.slice.call(bloc.querySelectorAll('.jb-diapo__vue'));
    if (!vues.length) return;

    var dits = Array.prototype.slice.call(bloc.querySelectorAll('.jb-diapo__dit-cadre'));
    var points = Array.prototype.slice.call(bloc.querySelectorAll('.jb-diapo__points button'));
    var duree = parseInt(bloc.dataset.duree, 10) || 6000;

    /* En regime pose, le texte n'a pas a se rejouer quand la
       diapositive suivante dit la meme chose. On donne a chaque cadre
       une empreinte — ses mots et ses liens — et on ne change de
       cadre que si l'empreinte change. C'est ce que « pose » veut
       dire : anime a l'apparition, puis il reste. */
    /* L'empreinte se lit ligne par ligne, pas sur tout le texte du
       cadre : le h1 de la premiere diapositive cache un deux-points
       pour les moteurs, et ce signe ne doit pas faire passer deux
       diapositives identiques pour differentes. */
    function empreinte(d) {
      return Array.prototype.map.call(d.querySelectorAll('.jb-diapo__titre, .jb-diapo__sous, a'), function (el) {
        return el.textContent.replace(/\s+/g, ' ').trim() + (el.getAttribute('href') || '');
      }).join('|');
    }
    var empreintes = dits.map(empreinte);
    var ditActif = 0;
    /* L'amorce de la section a pu jouer l'ouverture avant nous : elle
       laisse data-amorce (« attend » ou « ouverte ») et garde dans
       data-auto-voulu le reglage de lecture qu'elle a suspendu. */
    var amorce = bloc.dataset.amorce || '';
    var auto = (bloc.dataset.autoVoulu || bloc.dataset.auto) === 'true' && vues.length > 1 && !SOBRE.matches;
    var courante = 0;
    var enCours = false;
    var finMinuteur = null;

    /* La jauge ne doit pas partir avant l'ouverture : on retire la
       lecture automatique le temps que la premiere diapositive
       entre, ouvre() la remet. */
    bloc.dataset.auto = 'false';

    bloc.style.setProperty('--jb-d-temps', duree + 'ms');

    /* Toutes les diapositives partent hors champ, y compris la
       premiere : c'est ce qui permet de la faire entrer avec la meme
       animation que les suivantes, sur une scene encore vide. */
    /* La mise en attente doit etre INSTANTANEE. La feuille anime tout
       changement de transform des volets ; sans le cran data-saute,
       les volets partaient de leur position naturelle et glissaient
       lentement vers la coulisse, si bien qu'au moment d'entrer ils
       n'en etaient qu'a vingt pixels : les deux images semblaient
       deja la. Mesure trame par trame avant la correction. */
    if (!amorce) {
      vues.forEach(function (v) {
        v.dataset.saute = 'oui';
        v.dataset.etat = 'attente';
        v.setAttribute('aria-hidden', 'true');
      });
      void bloc.offsetHeight;
      vues.forEach(function (v) { delete v.dataset.saute; });
      dits.forEach(function (d) {
        d.removeAttribute('data-dit-actif');
        d.setAttribute('aria-hidden', 'true');
      });
    }
    bloc.dataset.prete = 'oui';
    bloc.dataset.joue = 'oui';

    /* Les diapositives suivantes recoivent leurs images une fois la
       premiere a l'ecran : elles ont cinq secondes devant elles, et la
       premiere n'a plus a partager la bande passante. */
    function hydrate() {
      bloc.querySelectorAll('[data-src], [data-srcset]').forEach(function (el) {
        if (el.dataset.srcset) { el.setAttribute('srcset', el.dataset.srcset); delete el.dataset.srcset; }
        if (el.dataset.src) { el.setAttribute('src', el.dataset.src); delete el.dataset.src; }
      });
    }

    function ouvre() {
      window.setTimeout(hydrate, 600);
      /* Marque la premiere entree : la feuille lui donne un decalage
         plus long entre les deux colonnes. On retire la marque une
         fois l'ouverture jouee, pour ne pas ralentir les suivantes. */
      bloc.dataset.ouverture = 'oui';
      window.setTimeout(function () { delete bloc.dataset.ouverture; }, 1700);
      vues[0].dataset.etat = 'active';
      vues[0].setAttribute('aria-hidden', 'false');
      if (bloc.dataset.regime === 'solidaire') {
        vues[0].setAttribute('data-dit-actif', '');
      } else if (dits[0]) {
        dits[0].setAttribute('data-dit-actif', '');
        dits[0].setAttribute('aria-hidden', 'false');
      }
      if (auto) bloc.dataset.auto = 'true';
    }

    /* On n'ouvre qu'une fois les images de la premiere diapositive
       arrivees. Sans cette attente, l'animation se joue sur des
       cadres vides et les photos apparaissent d'un bloc a la fin,
       ce qui donne exactement l'inverse de l'effet recherche.
       Un garde-fou d'une seconde et demie evite d'attendre une image
       qui ne viendra jamais. */
    /* Seules les images visibles comptent : la colonne de droite est
       masquee sur telephone, son image paresseuse ne se charge jamais
       et faisait attendre le garde-fou en entier. */
    var photos = Array.prototype.slice.call(vues[0].querySelectorAll('img'));
    var restantes = photos.filter(function (i) { return !i.complete && i.getClientRects().length; });
    var parti = false;

    /* L'amorce a ouvert, ou va le faire : il ne reste qu'a charger les
       images des diapositives suivantes et a lancer la lecture. */
    function apresAmorce() {
      window.setTimeout(hydrate, 600);
      if (auto) bloc.dataset.auto = 'true';
    }

    function lance() {
      if (parti) return;
      parti = true;
      /* Il ne suffit pas d'attendre deux trames. Au chargement, rien
         n'a encore ete peint : le navigateur voit l'etat d'attente et
         l'etat actif dans le meme cycle de style, les fusionne, et la
         transition ne se joue pas — les deux images sont la d'emblee.
         On lui impose donc une peinture, en lisant une mesure de mise
         en page puis en cedant la main le temps d'une trame reelle. */
      requestAnimationFrame(function () {
        void bloc.offsetHeight;
        window.setTimeout(ouvre, 70);
      });
    }

    if (amorce === 'ouverte') {
      apresAmorce();
    } else if (amorce === 'attend') {
      bloc.addEventListener('jb:diapo:ouverte', apresAmorce, { once: true });
    } else if (!restantes.length) {
      lance();
    } else {
      var reste = restantes.length;
      restantes.forEach(function (img) {
        function vue() { reste -= 1; if (reste <= 0) lance(); }
        img.addEventListener('load', vue, { once: true });
        img.addEventListener('error', vue, { once: true });
      });
      window.setTimeout(lance, 1500);
    }

    /* auDoigt : les images sont deja en place sous le doigt, on ne
       les remet pas en coulisse, on laisse la transition finir le
       chemin depuis la ou elles sont. */
    function versLa(cible, sens, auDoigt) {
      if (enCours || cible === courante || cible < 0 || cible >= vues.length) return;
      enCours = true;

      var avant = vues[courante];
      var apres = vues[cible];

      /* Le sens gouverne les regles de la feuille : vers l'avant les
         colonnes vont dans un sens, vers l'arriere dans l'autre. Il
         reste pose pendant toute la transition, sinon la sortante
         changerait de destination en cours de route. */
      bloc.dataset.sens = sens < 0 ? 'arriere' : 'avant';

      /* La diapositive qui entre est deja en coulisse, posee la sans
         transition a la fin de sa derniere sortie ; on s'en assure
         une fois encore, toujours sans transition. */
      if (!auDoigt) {
        apres.dataset.saute = 'oui';
        apres.dataset.etat = 'attente';
        void apres.offsetWidth;
        delete apres.dataset.saute;
      }

      avant.dataset.etat = 'sortante';
      avant.setAttribute('aria-hidden', 'true');
      apres.dataset.etat = 'active';
      apres.setAttribute('aria-hidden', 'false');
      if (auDoigt) {
        voletDe(avant).style.transform = '';
        voletDe(apres).style.transform = '';
      }

      if (bloc.dataset.regime === 'solidaire') {
        avant.removeAttribute('data-dit-actif');
        apres.setAttribute('data-dit-actif', '');
      } else if (empreintes[cible] !== empreintes[ditActif]) {
        dits.forEach(function (d, i) {
          if (i === cible) { d.setAttribute('data-dit-actif', ''); d.setAttribute('aria-hidden', 'false'); }
          else { d.removeAttribute('data-dit-actif'); d.setAttribute('aria-hidden', 'true'); }
        });
        ditActif = cible;
      }

      points.forEach(function (p, i) {
        if (i === cible) p.setAttribute('aria-current', 'true');
        else p.removeAttribute('aria-current');
        /* On relance la jauge en la retirant du flux d'animation le
           temps d'une image. */
        var jauge = p.querySelector('.jb-diapo__jauge');
        if (jauge) { jauge.style.animation = 'none'; void jauge.offsetWidth; jauge.style.animation = ''; }
      });

      courante = cible;

      finMinuteur = window.setTimeout(function () {
        /* La diapositive qui vient de sortir doit regagner sa place
           d'attente SANS transition : animee, elle retraverse l'ecran
           a l'envers, et si on la rappelle pendant ce retour elle
           repart du milieu du chemin au lieu du bord. */
        avant.dataset.saute = 'oui';
        avant.dataset.etat = 'attente';
        void avant.offsetWidth;
        delete avant.dataset.saute;
        libere(avant);
        libere(apres);
        enCours = false;
      }, 1050);
    }

    function suivante() { versLa((courante + 1) % vues.length, 1); }

    /* C'est la jauge qui donne le tempo : la diapositive change quand
       son trait arrive au bout. Une pause — survol, onglet cache,
       bouton — suspend l'animation du trait, et la reprise repart
       d'ou elle en etait. Un minuteur a part, lui, repartait de zero
       a chaque reprise et se desaccordait du trait. */
    function auBout() {
      if (enCours) { window.setTimeout(auBout, 200); return; }
      suivante();
    }

    bloc.addEventListener('animationend', function (e) {
      if (e.animationName === 'jb-diapo-jauge') auBout();
    });

    /* La pause demandee par le visiteur est distincte de la pause de
       survol : elle survit au depart de la souris. */
    var enPause = !auto;

    var bouton = bloc.querySelector('[data-lecture-bascule]');
    if (bouton) {
      bouton.addEventListener('click', function () {
        enPause = !enPause;
        bloc.dataset.lecture = enPause ? 'pause' : 'lecture';
        bouton.setAttribute('aria-pressed', enPause ? 'true' : 'false');
        if (!enPause) {
          /* Reprendre, c'est aussi demarrer un diaporama qui n'etait
             pas en lecture automatique au depart. */
          auto = true;
          bloc.dataset.auto = 'true';
          /* Lecture veut dire lecture : l'arret de survol ne retient
             pas le trait sous la souris qui vient de cliquer, ni
             sous le doigt qui l'a touche. Il reprendra a la prochaine
             entree de la souris. */
          arrete(false);
        }
      });
    }

    function arrete(oui) {
      bloc.dataset.arret = oui ? 'oui' : 'non';
    }


    points.forEach(function (p, i) {
      p.addEventListener('click', function () { versLa(i, i > courante ? 1 : -1); });
    });

    /* On suspend quand le visiteur survole, quand il tabule dans la
       section, et quand l'onglet passe en arriere-plan. */
    /* Seule une vraie souris suspend au survol : au doigt, le
       navigateur simule une entree de souris sans jamais la faire
       sortir, et le diaporama restait fige apres un simple tap. */
    bloc.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') arrete(true); });
    bloc.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') arrete(false); });
    /* Seul le focus venu du clavier suspend : un clic de souris sur
       un point laisse le focus dessus, et le diaporama restait fige
       apres avoir choisi une diapositive. Le bouton pause/lecture,
       lui, n'est jamais un arret : on y vient pour decider. */
    bloc.addEventListener('focusin', function (e) {
      if (e.target.closest('[data-lecture-bascule]')) return;
      var clavier = true;
      try { clavier = e.target.matches(':focus-visible'); } catch (x) {}
      if (clavier) arrete(true);
    });
    bloc.addEventListener('focusout', function () {
      if (!bloc.contains(document.activeElement)) arrete(false);
    });
    document.addEventListener('visibilitychange', function () { arrete(document.hidden); });

    bloc.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); versLa((courante + 1) % vues.length, 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); versLa((courante - 1 + vues.length) % vues.length, -1); }
    });

    /* Glissement, au doigt comme a la souris, parti de n'importe ou
       dans le bloc, texte et boutons compris ; seuls les traits et le
       bouton lecture gardent leur toucher. Sur telephone, les images
       suivent le doigt : la voisine entre a mesure, et au lacher le
       mouvement s'acheve si le geste a fait le tiers de l'ecran ou s'il
       etait vif ; sinon tout revient en place. Un nouveau geste peut
       partir pendant qu'une transition finit : on rattrape les images
       la ou elles sont. Sur ordinateur, ou les colonnes bougent
       verticalement, un geste franc suffit. On ne prend la main que si
       le geste est nettement horizontal, pour ne pas voler le
       defilement de la page. */
    var TEL = window.matchMedia('(max-width: 749px)');
    var departX = 0, departY = 0, departT = 0, courX = 0, courY = 0, pointeur = null;
    var derniers = [];
    /* Pendant qu'une image suit le doigt : position de depart de la
       diapositive courante, voisines en jeu (k = +1 a droite, -1 a
       gauche) et largeur de la scene. */
    var suivi = null;

    function voletDe(v) { return v.querySelector('.jb-diapo__volet--un'); }

    function libere(v) {
      var w = voletDe(v);
      w.style.transform = '';
      w.style.transitionDuration = '';
    }

    function positionX(v) {
      var m = getComputedStyle(voletDe(v)).transform.match(/matrix\(1, 0, 0, 1, (-?[\d.]+)/);
      return m ? parseFloat(m[1]) : 0;
    }

    function fige(v, x) {
      v.dataset.saute = 'oui';
      voletDe(v).style.transform = 'translateX(' + x + 'px)';
    }

    /* La voisine du cote k entre en jeu si elle n'y est pas. Avec deux
       diapositives seulement, la meme sert des deux cotes : elle change
       de bord, ce qui ne se voit pas puisqu'elle est alors hors champ. */
    function assure(k) {
      var vue = vues[(courante + k + vues.length) % vues.length];
      if (vue === vues[courante]) return;
      for (var i = 0; i < suivi.voisins.length; i++) {
        if (suivi.voisins[i].vue === vue) { suivi.voisins[i].k = k; return; }
      }
      vue.dataset.etat = 'suit';
      fige(vue, suivi.base + k * suivi.largeur);
      suivi.voisins.push({ vue: vue, k: k });
    }

    function engage(sens) {
      var largeur = bloc.querySelector('.jb-diapo__scene').clientWidth;
      var courant = vues[courante];
      var base = 0;
      var voisins = [];
      if (enCours) {
        /* Une transition court encore : on la rattrape. Ce qui sortait
           ou revenait reste en jeu, a sa place dans la bande. */
        window.clearTimeout(finMinuteur);
        enCours = false;
        base = positionX(courant);
        vues.forEach(function (v) {
          if (v.dataset.etat === 'sortante' || v.dataset.etat === 'suit') {
            var k = positionX(v) > base ? 1 : -1;
            v.dataset.etat = 'suit';
            fige(v, base + k * largeur);
            voisins.push({ vue: v, k: k });
          }
        });
      }
      fige(courant, base);
      suivi = { base: base, voisins: voisins, largeur: largeur };
      assure(sens);
    }

    function suit(dx) {
      /* La bande ne va pas plus loin qu'une diapositive de chaque cote. */
      var x = Math.max(-suivi.largeur, Math.min(suivi.largeur, suivi.base + dx));
      if (x < 0) assure(1);
      if (x > 0) assure(-1);
      voletDe(vues[courante]).style.transform = 'translateX(' + x + 'px)';
      suivi.voisins.forEach(function (n) {
        voletDe(n.vue).style.transform = 'translateX(' + (x + n.k * suivi.largeur) + 'px)';
      });
      return x;
    }

    function lache(dx, vif) {
      var s = suivi;
      var courant = vues[courante];
      var x = suit(dx);
      /* Ou va-t-on ? Un geste vif l'emporte : vers la suivante s'il va
         a gauche, la precedente s'il va a droite, meme si la bande n'a
         pas encore franchi le milieu. Sans vivacite, c'est la position
         qui decide : au-dela du tiers du chemin on passe, sinon on
         reste. */
      var k = 0;
      if (vif < 0) k = 1;
      else if (vif > 0) k = -1;
      else if (-x > s.largeur / 3) k = 1;
      else if (x > s.largeur / 3) k = -1;
      if (k !== 0) assure(k);
      suivi = null;
      var voisine = null;
      s.voisins.forEach(function (n) { if (n.k === k) voisine = n.vue; });
      if (!voisine) k = 0;
      /* Les transitions reprennent depuis la ou sont les images, avec
         une duree qui suit le chemin qui reste. */
      delete courant.dataset.saute;
      s.voisins.forEach(function (n) { delete n.vue.dataset.saute; });
      void bloc.offsetWidth;
      var ms = Math.max(200, Math.round(900 * Math.abs(-k * s.largeur - x) / s.largeur));
      voletDe(courant).style.transitionDuration = ms + 'ms';
      s.voisins.forEach(function (n) { voletDe(n.vue).style.transitionDuration = ms + 'ms'; });
      /* La voisine hors champ sort du jeu sans bruit ; seule reste
         celle qui se voit. */
      var visible = null;
      s.voisins.forEach(function (n) {
        if ((n.k === 1 && x < 0) || (n.k === -1 && x > 0)) { visible = n; return; }
        n.vue.dataset.saute = 'oui';
        n.vue.dataset.etat = 'attente';
        libere(n.vue);
        void n.vue.offsetWidth;
        delete n.vue.dataset.saute;
      });
      if (k !== 0) {
        /* Une voisine encore visible de l'autre cote part avec la
           bande, puis sort du jeu. */
        s.voisins.forEach(function (n) {
          if (n.vue === voisine || n.vue.dataset.etat !== 'suit') return;
          voletDe(n.vue).style.transform = 'translateX(' + ((n.k - k) * s.largeur) + 'px)';
          window.setTimeout(function () {
            if (n.vue.dataset.etat !== 'suit') return;
            n.vue.dataset.saute = 'oui';
            n.vue.dataset.etat = 'attente';
            libere(n.vue);
            void n.vue.offsetWidth;
            delete n.vue.dataset.saute;
          }, ms + 30);
        });
        versLa(vues.indexOf(voisine), k, true);
      } else {
        /* On reste : la courante regagne sa place et la voisine visible
           se retire du cote d'ou elle venait. */
        if (visible) bloc.dataset.sens = visible.k === 1 ? 'avant' : 'arriere';
        voletDe(courant).style.transform = '';
        if (visible) voletDe(visible.vue).style.transform = '';
        enCours = true;
        finMinuteur = window.setTimeout(function () {
          if (visible) { visible.vue.dataset.etat = 'attente'; libere(visible.vue); }
          libere(courant);
          enCours = false;
        }, ms + 30);
      }
    }

    function vivacite(e) {
      var vif = 0;
      var dx = courX - departX;
      if (Math.abs(dx) > 24 && e.timeStamp - departT < 300) vif = dx < 0 ? -1 : 1;
      if (derniers.length >= 2) {
        var a = derniers[0], b = derniers[derniers.length - 1];
        var v = (b.x - a.x) / Math.max(1, b.t - a.t);
        if (Math.abs(v) > 0.6) vif = v < 0 ? -1 : 1;
      }
      return vif;
    }

    /* Un glissement parti d'un bouton ne doit pas finir en clic sur
       ce bouton : le clic qui suit un geste est avale. */
    var gesteVenu = false;
    function avaleClic() {
      gesteVenu = true;
      window.setTimeout(function () { gesteVenu = false; }, 400);
    }
    bloc.addEventListener('click', function (e) {
      if (gesteVenu) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    bloc.addEventListener('dragstart', function (e) { e.preventDefault(); });

    bloc.addEventListener('pointerdown', function (e) {
      if (vues.length < 2 || pointeur !== null) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('.jb-diapo__gouverne, .jb-diapo__lecture')) return;
      pointeur = e.pointerId;
      departX = courX = e.clientX;
      departY = courY = e.clientY;
      departT = e.timeStamp;
      derniers = [];
      bloc.dataset.glisse = 'en-cours';
      arrete(true);
    });

    bloc.addEventListener('pointermove', function (e) {
      if (pointeur === null || e.pointerId !== pointeur) return;
      courX = e.clientX;
      courY = e.clientY;
      if (!TEL.matches || SOBRE.matches) return;
      var dx = courX - departX;
      var dy = courY - departY;
      if (!suivi) {
        /* On ne s'engage qu'une fois le geste nettement horizontal. */
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        engage(dx < 0 ? 1 : -1);
        try { bloc.setPointerCapture(pointeur); } catch (x) {}
      }
      derniers.push({ x: courX, t: e.timeStamp });
      if (derniers.length > 6) derniers.shift();
      suit(dx);
    });

    function finGeste(e) {
      if (pointeur === null || e.pointerId !== pointeur) return;
      pointeur = null;
      bloc.dataset.glisse = 'pret';
      if (e.type !== 'pointercancel') { courX = e.clientX; courY = e.clientY; }
      var dx = courX - departX;
      var dy = courY - departY;
      if (suivi || (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.5)) avaleClic();
      if (suivi) {
        lache(dx, vivacite(e));
      } else if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) versLa((courante + 1) % vues.length, 1);
        else versLa((courante - 1 + vues.length) % vues.length, -1);
      }
      arrete(false);
    }

    bloc.addEventListener('pointerup', finGeste);
    bloc.addEventListener('pointercancel', finGeste);
    /* La souris peut sortir de la scene avant d'etre relachee. */
    document.addEventListener('pointerup', function (e) { if (pointeur !== null) finGeste(e); });

    /* Le diaporama ne tourne que s'il est a l'ecran. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        entrees.forEach(function (x) { arrete(!x.isIntersecting); });
      }, { threshold: 0.2 }).observe(bloc);
    }
  }

  function demarre() {
    document.querySelectorAll('[data-jb-diapo]').forEach(monte);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarre);
  else demarre();

  /* L'editeur de theme recharge une section sans recharger la page. */
  document.addEventListener('shopify:section:load', demarre);
  document.addEventListener('shopify:block:select', function (e) {
    var bloc = e.target.closest('[data-jb-diapo]');
    if (bloc) bloc.dataset.arret = 'oui';
  });
})();
